import React, { useState, useEffect } from "react";
import { useScreenSize } from "../Utils";
import { useCustomScreen } from "../Utils";
export default function AboutSection() {
  const [fontSize, setFontSize] = useState(getFontSize(window.innerWidth));
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const devicePixelRatio = window.devicePixelRatio;

  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();

  useEffect(() => {
    const handleResize = () => {
      setFontSize(getFontSize(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function getFontSize(width) {
    if (width >= 1200) return "30px";
    if (width >= 992) return "30px";
    if (width >= 768) return "25px";
    if (width >= 576) return "28px";
    return "16px";
  }
  return (
    <section
      id=""
      style={{
        height: isSmallScreen
          ? "auto"
          : // : window.innerWidth > 1200 && window.innerWidth < 1300
          // ? "80vh"
          isXlScreen && devicePixelRatio >= 1.5
          ? "50vh "
          : isXlScreen
          ? "40vh"
          : isLargeScreen && isPortrait1024
          ? "40vh"
          : isLargeScreen && isLandscape1024
          ? "80vh"
          : is4kScreen
          ? "50vh"
          : "",
        paddingTop: is4kScreen ? "7rem" : "",
      }}
      className="mt-5"
    >
      <div className="container">
        <header className="section-header d-flex flex-column align-items-center justify-content-center">
          <h3
            className={isXlScreen && devicePixelRatio ? "" : "my-5"}
            style={{
              fontSize: is4kScreen
                ? "5.3rem"
                : isXxlScreen
                ? "2.8rem"
                : isXlScreen
                ? "2.6rem"
                : isIpadProPortrait
                ? "3rem"
                : isLargeScreen && isLandscape1024
                ? "2.5rem"
                : isLargeScreen && isPortrait1024
                ? "2.5rem"
                : isMediumScreen
                ? "2.4rem"
                : isSmallScreen
                ? "1.8rem"
                : "1.8rem",
            }}
          >
            A decade in and over 100,000 reports generated
          </h3>
          <div className=" w-md-75">
            <p
              style={{
                fontSize: is4kScreen
                  ? "3rem"
                  : isXxlScreen
                  ? "1.7rem"
                  : isXlScreen
                  ? "1.4rem"
                  : isIpadProPortrait
                  ? "1.5rem"
                  : isLargeScreen && isLandscape1024
                  ? "1.5rem"
                  : isLargeScreen && isPortrait1024
                  ? "1.9rem"
                  : isMediumScreen
                  ? "1.5rem"
                  : "1.3rem",
                textAlign: "center",
              }}
              className=""
            >
              As one of the original remote roof measurement services, members
              of our team helped pioneer the industry. A lot in the industry has
              changed, but our focus on customer service has not.{" "}
            </p>
          </div>

          <p
            className="mt-3"
            style={{
              fontSize: is4kScreen
                ? "3rem"
                : isXxlScreen
                ? "1.7rem"
                : isXlScreen
                ? "1.4rem"
                : isIpadProPortrait
                ? "2rem"
                : isLargeScreen && isLandscape1024
                ? "1.5rem"
                : isLargeScreen && isPortrait1024
                ? "1.9rem"
                : isMediumScreen
                ? "1.6rem"
                : "1.3rem",
            }}
          >
            <strong>Our success is directly tied to yours.</strong>
            <br />
            This is core to our values, actions and dedication to quality.{" "}
          </p>
        </header>
      </div>
    </section>
  );
}
